import { format, useState, useEffect, isSameDay, isSameMonth, startOfWeek,  addMonths, subMonths, addDays, startOfMonth, endOfMonth, PageStyle, ChevronLeftRed, ChevronRightRed, CalendarAction, useRouter, React, CommonAction, nb, enUS, sv, da, useTranslation } from '@/imports-files/components/calendar/calendar';


function CalendarMonth(props)
{
    // States
    const router = useRouter();
    const { i18n } = useTranslation();
    const commonAction = new CommonAction();
    const[currentMonth, setCurrentMonth] = useState(commonAction.getParamsToUrlWithoutRouter('current_date') ? new Date(commonAction.getParamsToUrlWithoutRouter('current_date').split('/').reverse().join('/')) : new Date());
    const [selectedDate, setSelectedDate] = useState(commonAction.getParamsToUrlWithoutRouter('current_date') ? new Date(commonAction.getParamsToUrlWithoutRouter('current_date').split('/').reverse().join('/')) : new Date());
    const calendarHash = {'current_date': (commonAction.getParamsToUrlWithoutRouter('current_date') ? new Date(commonAction.getParamsToUrlWithoutRouter('current_date').split('/').reverse().join('/')) : new Date()), 'is_my_interviews': commonAction.getParamsToUrlWithoutRouter('is_my_interviews') ||true, 'selected_tab':'month'};
    const calendarAction = new CalendarAction(props.setCalendarData, calendarHash, router, props.setCalendarDataArray);

    useEffect(()=>{
                     setCurrentMonth(commonAction.getParamsToUrlWithoutRouter('current_date') ? new Date(commonAction.getParamsToUrlWithoutRouter('current_date').split('/').reverse().join('/')) : new Date());
                     setSelectedDate(commonAction.getParamsToUrlWithoutRouter('current_date') ? new Date(commonAction.getParamsToUrlWithoutRouter('current_date').split('/').reverse().join('/')) : new Date());
                     calendarAction.getCalanderData(calendarHash);
                  }, [props.calandarFlagForRerender])

    const localeMap = {
        en: enUS,
        sv: sv,
        da: da,
        no: nb,
    };

    const getLocale = () => localeMap[i18n.language] || enUS;

    // Render name of month along with year
    const renderMonthYear = () => {
        const dateFormat = "MMMM yyyy"
        return (
        <div className={`${PageStyle.CalendarMonth}`}>
            <div className={`${PageStyle.CalendarMonth__LeftIcon}`}>
                <div className={`${PageStyle.CalendarMonth__Icon}`} onClick={async()=>
                {
                    await calendarAction.changeMonthHandle("prev", currentMonth, setCurrentMonth, props.setTodayClick)
                    let monthStartDay = startOfMonth(subMonths(currentMonth, 1))
                    let dayStr = format(monthStartDay, "ccc dd MMM yy", {locale: getLocale()});
                    calendarAction.onArrowClickHandle(monthStartDay, dayStr, props.setTodayClick);

                }}>
                    <span className="chevron-left"><ChevronLeftRed/></span>
                </div>
            </div>
            <div className={`${PageStyle.CalendarMonth__Content}`}>
                <span className={`${PageStyle.CalendarMonth__CurrentMonth}`}>{format(currentMonth, dateFormat, { locale: getLocale() })}</span>
            </div>
            <div className={`${PageStyle.CalendarMonth__RightIcon}`}>
                <div className={`${PageStyle.CalendarMonth__Icon}`} onClick={async()=> {
                    await calendarAction.changeMonthHandle("next", currentMonth, setCurrentMonth, props.setTodayClick)
                    let monthStartDay = startOfMonth(addMonths(currentMonth, 1))
                    let dayStr = format(monthStartDay, "ccc dd MMM yy", {locale: getLocale()});
                    calendarAction.onArrowClickHandle(monthStartDay, dayStr, props.setTodayClick);
                }}>
                    <span className="chevron-right"><ChevronRightRed/></span>
                </div>
            </div>
        </div>
        );
    }

    // Render name of week
    const renderMonthWeekdaysName = () =>{
        const dateFormat = 'iii';
        const days = [];

        let startDate = startOfWeek(currentMonth, {weekStartsOn: 1});

        for(let i = 0; i < 7; i++) {
            days.push(
                <div className={`${PageStyle.CalendarMonth__Content}`} key={i}>
                    {format(addDays(startDate, i), dateFormat, {locale: getLocale()})}
                </div>
            );
        }
        return (
            <div className={`${PageStyle.DateFNS__Calendar__WeekNames}`}>{days}</div>
        );
    }
    //------------------------------------------

    // Render days in month
    const renderMonthDaysCells = () =>{
        const monthStart = startOfMonth(currentMonth);
        const monthEnd = endOfMonth(monthStart);
        const startDate = startOfWeek(monthStart, { weekStartsOn: 1 });
        const endDate = startOfWeek(monthEnd, { weekStartsOn: 1 });

        const dateFormat = "d";
        const rows = [];

        let days = [];
        let day = startDate;
        let formattedDate = "";
        let ddmmYYDate = ''

        while (day <= endDate){
            for(let i = 0; i < 7; i++){
                formattedDate = format(day, dateFormat, {locale: getLocale()});
                ddmmYYDate = commonAction.getDateInDMYFormat(day)
                const cloneDay = day;
                days.push(
                    <div className= {`${PageStyle.DateFNS__Calendar__Cell} ${!isSameMonth(day, monthStart)? `${PageStyle.DateFNS__Calendar__Cell__Disabled}` : isSameDay(day, selectedDate) ? `${PageStyle.DateFNS__Calendar__Cell__Selected}` : ""}`}
                    key = {day} onClick={()=>{
                        const dayStr = format(cloneDay, "ccc dd MMM yy", {locale: getLocale()});
                        calendarAction.onMonthDateClickHandle(cloneDay, dayStr, setSelectedDate, props.setTodayClick);
                    }}>
                        <span className={`${PageStyle.CalendarMonth__Content__CurrentDate} ${calendarAction.greenDotClass(ddmmYYDate, props.calendarDataArray, PageStyle.CalendarMonth__Content__InterviewAvailable)}`}>{formattedDate}</span>
                        {/* <span className="bg">{formattedDate}</span> */}
                    </div>
                );
                day = addDays(day, 1);
            }
            rows.push(
                <div className={`${PageStyle.DateFNS__Calendar__Row}`} key={day}>
                    {days}
                </div>
            )
            days = [];
        }
        return (
            <div className={`${PageStyle.DateFNS__Calendar__Body}`}>{rows}</div>
        );
    }
    //------------------------------------------
    return(
        <div className={`${PageStyle.DateFNS__Calendar}`}>
            <div className={`${PageStyle.DateFNS__Calendar__Month}`}>
                <div className={`${PageStyle.DateFNS__Calendar__MonthYear}`}>
                    {renderMonthYear()}
                </div>
                <div className={`${PageStyle.DateFNS__Calendar__WeekDays}`}>
                    {renderMonthWeekdaysName()}
                </div>
                <div className={`${PageStyle.DateFNS__Calendar__DaysCells}`}>
                    {renderMonthDaysCells()}
                </div>
            </div>
        </div>
    );
}

export default React.memo(CalendarMonth)
